import { useEffect } from 'react';
import type React from 'react';

import { Form } from '@change/ds-forms';

import { PasswordInput } from '../PasswordInput';

import { useSignupStep } from './hooks/useSignupStep';

export const SignupStep: React.FC<EmptyProps> = () => {
	const {
		data: { password, passwordError },
		actions: { setStepData, submitStep, trackStepView },
	} = useSignupStep();

	useEffect(() => {
		trackStepView();
	}, [trackStepView]);

	return (
		<div>
			<Form
				data-qa="signup-step-form"
				onSubmit={() => {
					void submitStep();
				}}
			>
				<PasswordInput
					data-qa="signup-step-password-input"
					showHelp
					onChange={(value) => setStepData({ password: value })}
					value={password}
					error={passwordError}
				/>
			</Form>
		</div>
	);
};
